export default ({
    name : 'ProfileImage',
    data : function() {
        return {
        }
    },
    created () {
        this.code = 'profile_image';
        this.basic = this.getDetailDataByCode(this.code);
        return {}
    },
    computed : {
        isUseProfileImg () {
            if (this.basic.use == 'N') { return false; }
            if (this.basic.data.prf_img.value.length == 0 && this.basic.data.prf_img.default.length == 0) { return false; }
            return true;
        }
        , profileImg () {
            return (this.basic.data.prf_img.value.length == 0) ? this.basic.data.prf_img.default : this.basic.data.prf_img.value
        }
    },
    methods : {
    }
})
